const TICKS = [-50, -40, -30, -20, -10, 0, 10, 20, 30, 40, 50];

export const TunerGauge = ({ cents, active, inTune }) => {
  const c = active ? Math.max(-50, Math.min(50, cents)) : 0;
  const color = !active ? 'bg-white/20' : inTune ? 'bg-emerald-400' : 'bg-pink-400';
  return (
    <div data-testid="tuner-gauge" className="w-full max-w-xl mx-auto">
      <div className="relative h-24">
        <div className="absolute inset-x-0 top-1/2 h-px bg-white/10" />
        <div className="absolute left-1/2 -translate-x-1/2 top-2 bottom-2 w-[10%] rounded-md bg-emerald-400/10 border border-emerald-400/30" />
        {TICKS.map((t) => (
          <div
            key={t}
            className={`absolute top-1/2 -translate-y-1/2 w-px ${t === 0 ? 'h-14 bg-emerald-400/70' : t % 50 === 0 ? 'h-10 bg-white/30' : 'h-6 bg-white/15'}`}
            style={{ left: `${50 + t}%` }}
          />
        ))}
        <div
          data-testid="tuner-needle"
          className={`absolute top-1 bottom-1 w-1.5 -ml-[3px] rounded-full ${color} transition-[left,background-color] duration-100 ease-out ${active && inTune ? 'shadow-[0_0_18px_rgba(52,211,153,0.9)]' : active ? 'shadow-[0_0_14px_rgba(236,72,153,0.7)]' : ''}`}
          style={{ left: `${50 + c}%` }}
        />
      </div>
      <div className="flex justify-between text-[10px] uppercase tracking-[0.3em] text-white/40 mt-1">
        <span>♭ Flat</span>
        <span className={inTune && active ? 'text-emerald-400' : ''}>In Tune</span>
        <span>Sharp #</span>
      </div>
    </div>
  );
};
